import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { createSupabaseBrowserClient } from "@/lib/supabase/client";
import { safePostLoginPath } from "@/lib/safe-post-login-path";

export function AuthCallbackScreen() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [msg, setMsg] = useState("Finishing sign-in…");

  useEffect(() => {
    const next = safePostLoginPath(searchParams.get("next"));
    const sb = createSupabaseBrowserClient();
    void sb.auth
      .exchangeCodeForSession(window.location.href)
      .then(({ error }) => {
        if (error) {
          console.error("[auth/callback]", error);
          setMsg("Could not complete sign-in.");
          navigate(`/sign-in?error=auth&next=${encodeURIComponent(next)}`, { replace: true });
          return;
        }
        navigate(next, { replace: true });
      })
      .catch((e) => {
        console.error("[auth/callback]", e);
        setMsg("Could not complete sign-in.");
        navigate(`/sign-in?error=auth&next=${encodeURIComponent(next)}`, { replace: true });
      });
  }, [navigate, searchParams]);

  return (
    <div className="flex min-h-dvh items-center justify-center bg-[#faf8ff] px-4 text-sm text-zinc-600">
      {msg}
    </div>
  );
}
